import React from "react";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

function Sidebar({ isSidebarOpen }) {
  const location = useLocation();

  // Determine if a menu item is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  // Animation variants
  const menuItemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: (custom) => ({
      opacity: 1,
      x: 0,
      transition: { delay: 0.05 * custom, duration: 0.3 },
    }),
  };

  return (
    <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
      <div className="sidebar-content">
        <ul className="sidebar-menu">
          <motion.li
            className={`menu-item ${isActive("/dashboard") ? "active" : ""}`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={1}
          >
            <Link to="/dashboard" className="menu-link">
              <span className="material-icons icon-home">home</span>
              <span>Dashboard</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/tournament-dashboard") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={2}
          >
            <Link to="/tournament-dashboard" className="menu-link">
              <span className="material-icons icon-wordpress">
                emoji_events
              </span>
              <span>Tournament Dashboard</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/UserManagement") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={3}
          >
            <Link to="/UserManagement" className="menu-link">
              <span className="material-icons icon-support">support_agent</span>
              <span>User Management</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/TunamentPlayers") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={4}
          >
            <Link to="/TunamentPlayers" className="menu-link">
              <span className="material-icons icon-wordpress">
                directions_run
              </span>
              <span>Tunament Players</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/TournamentPlayerReview") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={5}
          >
            <Link to="/TournamentPlayerReview" className="menu-link">
              <span className="material-icons icon-wordpress">
                playlist_add_check
              </span>
              <span>New Player Review</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/TournamentSquads") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={6}
          >
            <Link to="/TournamentSquads" className="menu-link">
              <span className="material-icons icon-wordpress">group</span>
              <span>Tournament Squads</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/TournamentFixture") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={7}
          >
            <Link to="/TournamentFixture" className="menu-link">
              <span className="material-icons icon-wordpress">event</span>
              <span>Tournament Fixture</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/TournamentSchedule") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={8}
          >
            <Link to="/TournamentSchedule" className="menu-link">
              <span className="material-icons icon-wordpress">schedule</span>
              <span>Tournament Schedule</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${isActive("/team-logos") ? "active" : ""}`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={9}
          >
            <Link to="/team-logos" className="menu-link">
              <span className="material-icons icon-wordpress">image</span>
              <span>Team Logos</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${isActive("/sponsor-settings") ? "active" : ""}`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={10}
          >
            <Link to="/sponsor-settings" className="menu-link">
              <span className="material-icons icon-wordpress">campaign</span>
              <span>Sponsor Settings</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/player-photo-submissions") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={11}
          >
            <Link to="/player-photo-submissions" className="menu-link">
              <span className="material-icons icon-wordpress">
                account_box
              </span>
              <span>Player Photos</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${isActive("/LiveScores") ? "active" : ""}`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={12}
          >
            <Link to="/LiveScores" className="menu-link">
              <span className="material-icons icon-wordpress">
                sports_score
              </span>
              <span>Live Scores</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/moderation-reports") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={13}
          >
            <Link to="/moderation-reports" className="menu-link">
              <span className="material-icons icon-wordpress">policy</span>
              <span>Moderation Reports</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${isActive("/logs") ? "active" : ""}`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={14}
          >
            <Link to="/logs" className="menu-link">
              <span className="material-icons icon-logs">history</span>
              <span>System Logs</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${isActive("/cache") ? "active" : ""}`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={15}
          >
            <Link to="/cache" className="menu-link">
              <span className="material-icons icon-cache">memory</span>
              <span>Cache Management</span>
            </Link>
          </motion.li>

          <motion.li
            className={`menu-item ${
              isActive("/visitor-bandwidth") ? "active" : ""
            }`}
            variants={menuItemVariants}
            initial="hidden"
            animate="visible"
            custom={16}
          >
            <Link to="/visitor-bandwidth" className="menu-link">
              <span className="material-icons icon-bandwidth">analytics</span>
              <span>Visitor Analytics</span>
            </Link>
          </motion.li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
